import type { Middleware } from '@reduxjs/toolkit';

const localStorageHandler: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  // Get the current state after the action is processed
  const state = store.getState();

  // Save specific parts of the state to local storage
  //localStorage.setItem('store', JSON.stringify(state));

  return result;
};

export default localStorageHandler;
